import React from 'react'

export const Angels = () => {
  return (
      <div className='recruiting-email'>
        <div className="recruiting-email__title">Subject: Angels</div>
        <div className="recruiting-email__body">
          <p>
            <span className="redact">Hey William,</span>
          </p>
          <p>
            I realize <span className="redact">I didn't send much info on us - Here's the</span> high<span className="redact">-level</span> on Onlook <span className="redact">:</span>
          </p>
          <p>
            <span className="redact">We built an open-source, visual editor for code that merges design, development, and Al.</span>
          </p>
          <p>Onlook is <span className="redact">the fastest way for anyone to build, deploy, and iterate on websites and web apps in code. We have tens of </span>thousands of <span className="redact">designers and developers who are using the product, and we have a lot we could use your help with building.</span></p>
          <p><span className="redact">Our investors include Leonis Capital, Joe Gebbia (Cofounder of Aironb), and</span> angels <span className='redact'>at Apple, Notion, Microsoft, Linkedin and Lyft, and</span> we <span className='redact'>have an incredibly cool office in South Park (which I'd</span> love <span className='redact'>for you to</span> come by <span className='redact'>and see sometime!).</span></p>
          <p>With your permission<span className="redact">, I can send over a calendar link to find a</span> time <span className="redact">that works </span>for both of us.</p>
          <p><span className="redact">Mr. Name</span></p>
        </div>
      </div>
  )
}

export default Angels
